import { render, staticRenderFns } from "./html/InputDocNumber.html?vue&type=template&id=0b80ea4c&lang=html&external"
import script from "./js/InputDocNumber.js?vue&type=script&lang=js&external"
export * from "./js/InputDocNumber.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports